<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const sections = [
  { key: 'FINANCIAL', icon: 'i-lucide-wallet' },
  { key: 'INVENTORY', icon: 'i-lucide-warehouse' },
  { key: 'SUPPLIER_CONTACTS', icon: 'i-lucide-book-user' },
  { key: 'GUEST_REGISTRY', icon: 'i-lucide-id-card' },
];
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
        {{ t('TDF.ADMIN.HEADER') }}
      </h3>
      <p class="text-sm text-slate-600 dark:text-slate-300">
        {{ t('TDF.ADMIN.DESCRIPTION') }}
      </p>
    </div>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div
        v-for="section in sections"
        :key="section.key"
        class="flex items-center gap-4 rounded-lg border border-slate-200 bg-white p-4 transition-shadow hover:shadow-sm dark:border-slate-600 dark:bg-slate-800"
      >
        <span class="size-10 text-blue-500" :class="section.icon" />
        <div class="flex flex-col">
          <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
            {{ t(`TDF.ADMIN.${section.key}`) }}
          </span>
          <span class="text-xs text-slate-500">
            {{ t('TDF.COMMON.COMING_SOON') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
